import React, { FC } from "react";
import "./TabItem.scss";

type TProps = {
  value: string;
  label?: string;
  activeTab: string;
  onChange: (key: string) => void;
};

const TabItem: FC<TProps> = ({ value, label, activeTab, onChange }) => (
  <li className="nav-item">
    <button
      className={`nav-link ${activeTab === value ? "active bg-dark" : ""}`}
      type="button"
      onClick={() => onChange(value)}
    >
      {label || value}
    </button>
  </li>
);

export default TabItem;
